<template>
    <div>
        <v-dialog v-model="show" persistent fullscreen>
            <v-card>
                <v-app-bar dark text color="secondary">
                    <h2 class="page-title">{{ $t('checklisttemplate.available_templates') }}</h2>

                    <v-spacer></v-spacer>

                    <v-form ref="form" class="mt-8 d-none d-sm-flex">
                        <v-container grid-list-md>
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-text-field
                                        :label="$t('global.search')"
                                        v-model="search_params.any"
                                        autocomplete="new-password"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-select
                                        v-model="search_params.filter"
                                        :items="$dd_admin_module_templates_filter()"
                                        item-text="text"
                                        item-value="key"
                                        :label="$t('checklisttemplate.status')"
                                        hide-details
                                        @change="getListHandler()"
                                    >
                                    </v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>

                    <action-button type="cancel" @click="cancel" />
                    <action-button type="save" :text="$t('global.import')" @click="importChecklistTemplate" :disabled="selected.length == 0" />
                </v-app-bar>

                <v-divider></v-divider>

                <v-card-text class="py-0 mt-4">
                    <v-data-table
                        :loading="loadingForms"
                        :loading-text="$t('global.loading_text')"
                        :no-data-text="$t('global.no_data_available')"
                        :no-results-text="$t('global.no_data_available')"
                        :headers="headers"
                        :items="forms"
                        :items-per-page.sync="items_per_page"
                        :search="search_params.any"
                        :footer-props="{
                            'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                            'items-per-page-all-text': $t('global.items_per_page_all_text'),
                            'items-per-page-text': $t('global.items_per_page_text'),
                            'page-text': $t('global.page_text')
                        }"
                        item-key="id"
                        :show-select="true"
                        v-model="selected"
                        :sort-by="'title'"
                        :sort-desc="false"
                    >
                    <template v-slot:item.checklist_type="{ item }">
                        {{ $dd_checklisttemplate_checklist_type(item.checklist_type) }}
                    </template>
                    <template v-slot:item.updated_at="{ item }">
                        {{ moment(item.updated_at, MYSQL_DATETIME_FORMAT).format(DATE_FORMAT + " " + DATETIME_FORMAT_TIME_SIMPLE) }}
                    </template>
                     <template v-slot:item.status="{ item }">
                        {{ $dd_checklisttemplate_checklist_status(item.status) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <action-button type="view" :icon_only="true" small @click="getSingleRecordHandler(item.id)" :loading="btnLoading" />
                    </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="formdialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
            <form-builder 
                :key="reRenderFormBuilder"
                :formProp="formProp" 
                :adminChecklistAPIToken="ADMIN_CHECKLIST_API_TOKEN"
                @closeForm="closeDialogHandler">
            </form-builder>
        </v-dialog>
    </div>
</template>

<script>
import rowsPerPage from '@/mixins/rowsPerPage'
export default {
    name: "AdminFormsPopup",

    props: {
        show: {
            type: Boolean,
            required: true
        },
    },

    mixins: [rowsPerPage],

    components: {
        'form-builder': () => import('@/mixins/components/checklist/builder/Index.vue')
    },

    data() {
        return {
            url: "",
            selected: [],

            forms: [],
            loadingForms: false,

            formProp: {},
            formdialog: false,
            reRenderFormBuilder: 0,

            refresh: false,
            search_params: {
                name: "",
                status: 1,
                filter: "new-and-updated",
            },
            btnLoading: false,
        };
    },

    computed: {
        headers() {
            return [
            { text: this.$t('checklisttemplate.title'), value: 'title', },
            { text: this.$t('checklisttemplate.checklist_type'), value: 'checklist_type', },
            { text: this.$t('checklisttemplate.status'), value: 'status', },
            { text: this.$t('checklisttemplate.updated_on'), value: 'updated_at', },
            { text: this.$t("global.actions"), value: "actions", width: "120px", align: "end", sortable: false }
        ]
        }
    },

    watch: {
        pagination: {
        handler (val) {
            // this.getListHandler()
        },
        deep: true
        }
    },
    created() {
        if(this.show)
         this.getListHandler();
    },

    methods: {
        getListHandler() {
            this.loadingForms = true

            // Status: 2 = completed
            axios.get(this.API_URL + `checklist-template/admintemplates?show_all=true&query_filter=${this.search_params.filter}`).then(response => {
                if(response.status == 200) {
                    this.forms = response.data.data ? response.data.data : [];
                    // this.forms.map(form => {
                    //     form.type = this.getChecklistType(form.checklist_type)
                    //     return form
                    // })
                }
            }).catch(error => {
                this.$handleServerSideError(error)
            }).then(() => { 
                this.loadingForms = false 
            })
        },

        cancel() {
            this.$emit("callback_adminforms_cancel")
        },

        importChecklistTemplate() {
            let vm = this;

            axios.post(this.API_URL + "checklist-template/admintemplates/import", this.selected).then(res => {
                this.$awn.success(vm.$t("checklisttemplate.import_success"));
                this.$emit("callback_adminforms_submit", this.selected)
            }).catch(err => {
                this.$awn.alert(vm.$t("checklisttemplate.import_failed"));
            });
        },

        async getSingleRecordHandler (id = null) {
            this.btnLoading = true

            if(id) {
                await axios.get(this.API_URL + `checklist-template/admintemplate/${id}`).then(response => {
                    if(response.status == 200) {
                        let record = response.data.data;
                        
                        this.formProp = record;
                        this.formProp.id = record.id
                        this.formProp.name = record.title
                        this.formProp.status = record.status
                        this.formProp.is_active = null
                        this.formProp.form_id = record.checklist_template_api_id;
                        this.formProp.mode = "admin";
                    }
                }).catch(error => {
                    this.$handleServerSideError(error)
                })
            }

            this.btnLoading = false
            this.openDialoghandler();
        },

        openDialoghandler() {
            this.reRenderFormBuilder++;
            this.formdialog = true;
        },

        closeDialogHandler () {
            this.formdialog = false
            this.formProp = {
                id: null,
                is_active: true
            };
        },
    }
};
</script>

<style scoped>
</style>